/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Filter detections by verdict
 * @export
 */
export const ControlVerdict9 = {
    Malicious: 'MALICIOUS',
    Suspicious: 'SUSPICIOUS',
    Benign: 'BENIGN'
} as const;
export type ControlVerdict9 = typeof ControlVerdict9[keyof typeof ControlVerdict9];


export function ControlVerdict9FromJSON(json: any): ControlVerdict9 {
    return ControlVerdict9FromJSONTyped(json, false);
}

export function ControlVerdict9FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlVerdict9 {
    return json as ControlVerdict9;
}

export function ControlVerdict9ToJSON(value?: ControlVerdict9 | null): any {
    return value as any;
}

